import { InfoCircleFilled } from "@ant-design/icons";
import { Flex, Popover } from "antd";

import "./FieldWithInfo.style.less";

const FieldWithInfo = ({ info, field }) => {
  return (
    <Flex gap="small" className="field-with-info">
      {field}
      {info ? (
        <Popover content={info}>
          <InfoCircleFilled />
        </Popover>
      ) : null}
    </Flex>
  );
};

export default FieldWithInfo;
